import { combineReducers } from 'redux'
import { disableStatusReducer, activeJobReducer, workExperienceReducer, UploadProgressReducer, UploadStorageReducer, sidebarReducer, userReducer, jobReducer, admissionReducer } from '.'
import UploadMessageReducer from './FileManager/UploadMessageReducer'
import referenceReducer from './Verification/referenceReducer'

const rootReducer = combineReducers({
  uploadProgress: UploadProgressReducer,
  uploadMessage: UploadMessageReducer,
  uploadedFiles: UploadStorageReducer,
  reference: referenceReducer,
  disableStatus: disableStatusReducer,
  workExperienceReducer,
  sidebar: sidebarReducer,
  user: userReducer,
  job: jobReducer,
  activeJob: activeJobReducer,
  admissionId: admissionReducer

})

export default rootReducer
